<template>
  <MyShareDashboard v-if="isAuth"/>
  <LoginPage v-else/>
</template>

<style>
@import "~apexcharts/dist/apexcharts.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~floating-vue/dist/style.css";
</style>

<script>
import MyShareDashboard from "./pages/MyShareDashboard"
import LoginPage from "./pages/LoginPage";
import store from "./stores/store";

export default {
  components: {
    LoginPage,
    MyShareDashboard,
  },

  computed: {
    isAuth() {
      return store.getters.isAuth
    }
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      window.history.replaceState({}, document.title, window.location.pathname);
      store.dispatch('setToken', {token});
    }
  },
}
</script>
